import type {
  HealthResponse,
  InvoicePdfUrlResponse,
  PhotoUploadUrlRequest,
  PhotoUploadUrlResponse,
  PublicFeedbackRequest,
  PublicInvoice,
  SubmitFeedbackBody,
  SubmitFeedbackResponse,
} from '@fois-utsavvoice/shared';
import { apiRequest } from './client.js';

export function getHealth(): Promise<HealthResponse> {
  return apiRequest<HealthResponse>('/v1/health');
}

export function getPublicFeedback(token: string): Promise<PublicFeedbackRequest> {
  return apiRequest<PublicFeedbackRequest>(`/v1/public/feedback/${encodeURIComponent(token)}`);
}

export function requestPhotoUploadUrl(
  token: string,
  body: PhotoUploadUrlRequest,
): Promise<PhotoUploadUrlResponse> {
  return apiRequest<PhotoUploadUrlResponse>(
    `/v1/public/feedback/${encodeURIComponent(token)}/photo-upload-url`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export async function uploadPhotoToPresignedUrl(
  uploadUrl: string,
  file: File,
  headers: Record<string, string>,
): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers,
    body: file,
  });
  if (!response.ok) {
    throw new Error('PHOTO_UPLOAD_FAILED');
  }
}

export function submitPublicFeedback(
  token: string,
  body: SubmitFeedbackBody,
  idempotencyKey: string,
): Promise<SubmitFeedbackResponse> {
  return apiRequest<SubmitFeedbackResponse>(
    `/v1/public/feedback/${encodeURIComponent(token)}/responses`,
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'Idempotency-Key': idempotencyKey },
    },
  );
}

export function getPublicInvoice(accessToken: string): Promise<PublicInvoice> {
  return apiRequest<PublicInvoice>(`/v1/public/invoices/${encodeURIComponent(accessToken)}`);
}

export function getPublicInvoicePdfUrl(accessToken: string): Promise<InvoicePdfUrlResponse> {
  return apiRequest<InvoicePdfUrlResponse>(
    `/v1/public/invoices/${encodeURIComponent(accessToken)}/pdf-url`,
  );
}
